module.exports = __webpack_public_path__ + "static/media/ddk-GINSSEN_product_120g_a.41e76edf.png";